import { getScrollbarWidth } from '../utils';

draw('shop-draw');
draw('search-draw');
draw('nav-draw');
draw('book-draw');
draw('modal-draw');

function draw(id) {
	const element = document.getElementById(id);

	if (!element) {
		return;
	}

	const contents = element.querySelector('.js-draw-contents');

	let isOpen = false;
	const openClass = 'is-open';

	init();

	function init() {
		const openers = Array.from(document.querySelectorAll(`[data-open-draw="${id}"]`));
		const closers = Array.from(document.querySelectorAll(`[data-close-draw="${id}"]`));

		openers.forEach(element => element.addEventListener('click', function(event) {
			open();
			event.preventDefault();
		}));

		closers.forEach(element => element.addEventListener('click', function(event) {
			close();
			event.preventDefault();
		}));
	}

	function onKeydown(event) {
		if (event.key == 'Escape') {
			close();
		}
	}

	function onDocumentClick(event) {
		if (!contents.contains(event.target) && isOpen) {
			close();
		}
	}

	function open() {
		if (isOpen) {
			return;
		}

		element.classList.add(openClass);

		if (element.id != 'search-draw') {
			document.body.style.width = '100%';
			document.body.style.overflow = 'hidden';
			document.body.style.paddingRight = `${getScrollbarWidth()}px`;
		}

		element.addEventListener('click', onDocumentClick);
		element.addEventListener('touchstart', onDocumentClick);
		document.addEventListener('keydown', onKeydown);
		contents.addEventListener('transitionend', onTransitionEnd);

		isOpen = true;
	}

	function close() {
		if (!isOpen) {
			return;
		}

		element.classList.remove(openClass);

		document.body.style = '';

		document.removeEventListener('keydown', onKeydown);
		element.removeEventListener('click', onDocumentClick);
		element.removeEventListener('touchstart', onDocumentClick);

		isOpen = false;
	}

	function onTransitionEnd() {
		contents.removeEventListener('transitionend', onTransitionEnd);
	}
}
